var exports = {
  "qu": "ArtifactName__H6qmks",
  "FV": "Artifact__t7u2vs",
  "DZ": "Heading___0g7o6",
};

module.exports = exports;
